<template>
  <div class="iuk">
    <img class="iuq" src="/static/img/Group_top.png" alt="KZcredit" @click="$router.push('/')" />
    <div class="top_nav">
      <div :class="typeindex == 1 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(1)">Как получить</div>
      <div :class="typeindex == 2 ? 'top_nav-active' : 'top_nav-item'" @click="goFn(2)">Как погасить</div>
    </div>
    <div class="uvf">
      <img class="nlk" src="/static/img/1.png" alt="" />
      <div class="uew">+7 778 325 9734</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HeadTab",
    props: {
      typeindex: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {

      };
    },
    methods: {
      goFn(type) {
        if (type == 1) {
          this.$router.push('/obtain')
        } else if(type == 2){
          this.$router.push('/tutorial')
        }
      },
    }
  };
</script>

<style scoped>
  .iuk{
    background: rgba(255, 255, 255, 1);
    box-shadow: 0rem 0.01rem 0.02rem rgba(0, 0, 0, 0.1);
    padding: 0.11rem 1.58rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .iuq{
    width: 1.11rem;
    height: 0.32rem;
    cursor: pointer;
  }
  .top_nav{
    display: flex;
    align-items: center;
    gap: 0.32rem;
  }
  .top_nav-item{
    color: #64748b;
    font-family: Montserrat;
    font-weight: 500;
    font-size: 0.08rem;
    cursor: pointer;
  }
  .uvf{
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.06rem;
    background: rgba(230, 240, 250, 1);
    padding: 0.08rem 0.11rem;
    cursor: pointer;
  }
  .nlk{
    width: 0.13rem;
    height: 0.13rem;
    margin-right: 0.03rem;
  }
  .uew{
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.13rem;
  }

  .top_nav-active{
    color: rgba(0, 102, 204, 1);
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.08rem;
    cursor: pointer;
  }

  @media screen and (max-width: 1200px) {
    .iuk {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .top_nav {
      gap: 0.2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .iuk {
      padding-top: 0.16rem;
      padding-bottom: 0.16rem;
      flex-wrap: wrap;
      gap: 0.14rem;
    }
    .top_nav {
      order: 3;
      width: 100%;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeadTab.vue